import {createStore, combineReducers, applyMiddleware} from "redux";
import thunk from "redux-thunk"
//Asset
import AssetReducer from './asset/asset.js'
// import GlobalAssetReducer from './asset/global_asset.js'
import PhotoReducer from './asset/photo.js'
import TrackingReducer from './asset/tracking.js'

//Location
import LocationReducer from './location/location.js'
import SiteReducer from './location/site.js'
//Master
import AssetStatusReducer from './master/asset_status.js'
import AssetTypeReducer from './master/asset_type.js'
import ContactReducer from './master/contact.js'
import DepartementReducer from './master/departement.js'
import SiteStatusReducer from './master/site_status.js'
import SiteTypeReducer from './master/site_type.js'
import VendorReducer from './master/vendor.js'
import MaintenanceTypeReducer from './master/maintenance_type.js'
import ContractorReducer from './master/contractor.js'
//User
import RoleReducer from './user/role.js'
import UserModelReducer from './user/model.js'
import UserReducer from "./user.js";

//Super Level master
import CurrencyReducer from './super/master/currency.js'
import CityReducer from './super/master/city.js'

//Helper
import RequestReducer from './request.js'
import RequestPropsReducer from './request.props.js'

//Comment
import CommentReducer from './comment/comment.js'

//Items
import {AssetTagReducer} from './items.js'

import TenantReducer from './tenant'

export default createStore(
    combineReducers({
        AssetReducer,
        PhotoReducer,
        TrackingReducer,

        LocationReducer,
        SiteReducer,

        AssetStatusReducer,
        AssetTypeReducer,
        ContactReducer,
        DepartementReducer,
        SiteStatusReducer,
        SiteTypeReducer,

        VendorReducer,
        CityReducer,

        MaintenanceTypeReducer,

        CurrencyReducer,

        RoleReducer,
        UserModelReducer,
        UserReducer,

        RequestReducer,
        RequestPropsReducer,

        CommentReducer,
        ContractorReducer,
        AssetTagReducer,
        TenantReducer
    }),
    {},
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(thunk)
);



// WEBPACK FOOTER //
// ./src/App/store/index.js